import { useCallback, useMemo } from "react";
import { useI18nContext } from "@hopper-b2b/i18n";
import { MinimumBagCount } from "~core-cars/types";

export const useFilterBags = () => {
  const { t } = useI18nContext();
  const getLabel = useCallback(
    (minBags: MinimumBagCount) => {
      return t("core-cars.filters.minimumBags.options.bags", {
        count: minBags,
      });
    },
    [t]
  );
  const options = useMemo(() => {
    return MinimumBagCount.map((v) => {
      return {
        value: v.toString(),
        label: getLabel(v),
      };
    });
  }, [getLabel]);

  return useMemo(
    () => ({
      options,
    }),
    [options]
  );
};
